import React, { useState } from "react";
import { Home, Users, Landmark, Wallet, ShieldCheck, BarChart3, History } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import AppHeader from "@/components/AppHeader";
import BottomNav from "@/components/BottomNav";
import MemberHome from "@/components/screens/MemberHome";
import AdminHome from "@/components/screens/AdminHome";
import MembersScreen from "@/components/screens/MembersScreen";
import LoansScreen from "@/components/screens/LoansScreen";
import JamaScreen from "@/components/screens/JamaScreen";
import VerifyScreen from "@/components/screens/VerifyScreen";
import ReportsScreen from "@/components/screens/ReportsScreen";
import HistoryScreen from "@/components/screens/HistoryScreen";

export default function DashboardPage() {
  const { member } = useAuth();
  const isAdmin = member.role === "admin";
  const [tab, setTab] = useState("home");

  const tabs = isAdmin
    ? [
        { key: "home", hi: "घर", en: "Home", icon: Home },
        { key: "members", hi: "सदस्य", en: "Members", icon: Users },
        { key: "verify", hi: "सत्यापन", en: "Verify", icon: ShieldCheck },
        { key: "loans", hi: "ऋण", en: "Loans", icon: Landmark },
        { key: "reports", hi: "रिपोर्ट", en: "Reports", icon: BarChart3 },
      ]
    : [
        { key: "home", hi: "घर", en: "Home", icon: Home },
        { key: "members", hi: "सदस्य", en: "Members", icon: Users },
        { key: "loans", hi: "ऋण", en: "Loans", icon: Landmark },
        { key: "jama", hi: "जमा", en: "Deposit", icon: Wallet },
        { key: "history", hi: "इतिहास", en: "History", icon: History },
      ];

  const render = () => {
    switch (tab) {
      case "home":
        return isAdmin ? <AdminHome setTab={setTab} /> : <MemberHome setTab={setTab} />;
      case "members":
        return <MembersScreen />;
      case "loans":
        return <LoansScreen />;
      case "jama":
        return <JamaScreen />;
      case "verify":
        return <VerifyScreen />;
      case "reports":
        return <ReportsScreen />;
      case "history":
        return <HistoryScreen />;
      default:
        return null;
    }
  };

  return (
    <div className="max-w-md mx-auto min-h-screen bg-slate-50 relative shadow-xl border-x border-slate-200 pb-24">
      <AppHeader />
      <div className="px-4 py-4 animate-fade-up" key={tab}>
        {render()}
      </div>
      <BottomNav tabs={tabs} active={tab} onChange={setTab} />
    </div>
  );
}
